import { Box } from '@zillow/constellation-10';
import { PostCard } from '@zillow/zrs-cms';
import React from 'react';

import type { Post } from '../../types/posts';
import PostsPagination from '../PostsPagination/PostsPagination';

export interface PostGridProps {
    posts: Post[];
    pages: number;
    page: number;
    archiveCategory?: string;
    baseLink: string;
    query?: Record<string, string>;
    incrementPaginationLinks?: boolean;
}

export default function PostGrid({
    posts,
    pages,
    page,
    archiveCategory,
    baseLink,
    query,
    incrementPaginationLinks,
}: PostGridProps) {
    return (
        <React.Fragment>
            <Box
                css={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
                    gap: 'loose',
                }}
            >
                {posts.map((post, index) => (
                    <Box
                        key={post.id}
                        css={{
                            gridColumn: { base: 'span 12', md: 'span 6' },
                        }}
                    >
                        <PostCard
                            url={{ href: post.link }}
                            alignment="vertical"
                            size="md"
                            category={getPrimaryCategory(post, archiveCategory)}
                            forceHideReadTime
                            forceShowCategory
                            loading={index === 0 ? 'eager' : 'lazy'}
                            title={post.title.raw}
                            image={post.featuredImage || undefined}
                        />
                    </Box>
                ))}
            </Box>
            <PostsPagination
                page={page}
                pages={pages}
                baseLink={baseLink}
                query={query}
                incrementPaginationLinks={incrementPaginationLinks}
            />
        </React.Fragment>
    );
}

function getPrimaryCategory(post: Post, archiveCategory?: string) {
    let badge: unknown;

    if (archiveCategory) {
        const relatedSubcategory = post.categories.find(
            (category: { parent: number | string }) =>
                String(category.parent) === archiveCategory
        );
        if (relatedSubcategory) {
            return relatedSubcategory;
        }
    }

    if (!badge && post.primaryCategory) {
        return post.primaryCategory;
    }

    if (!badge && post.categories.length) {
        return post.categories[0];
    }

    return null;
}
